import React from 'react';
import ShoppingCart from './ShoppingCart';

function App() {
    return (
      <div>
      <ShoppingCart/>
      </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js